import { Button, EmptyState, Icons } from "@dms/ui";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAuth } from "../auth/AuthContext";

// 12-screen-spec §14 (403).
export function ForbiddenPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [loggingOut, setLoggingOut] = useState(false);

  const handleLogout = async () => {
    setLoggingOut(true);
    try {
      await logout();
    } catch {
      // AuthContext clears local auth state even if the backend logout request fails.
    }
    navigate("/login", { replace: true });
  };

  return (
    <div role="alert" style={{ paddingTop: 40 }}>
      <EmptyState
        icon={<Icons.lock size={26} />}
        title="У вас немає доступу до цього розділу"
        description="Якщо вважаєте це помилкою — зверніться до системного адміністратора."
        action={
          <Button
            variant="secondary"
            loading={loggingOut}
            iconLeft={<Icons.lock size={18} />}
            onClick={() => void handleLogout()}
          >
            Вийти
          </Button>
        }
      />
    </div>
  );
}
